import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import appConfig from 'app-config';
import { withRetry } from './retryService';


const isGPA = appConfig.portalCode === 'GPA';

export default {
    createHistoryEvents(request, additionalHeaders = {}) {
        const serviceName = isGPA ? 'gatewayhistory' : 'history';

        return withRetry(() => JsonRPCService.send(getProxiedServiceUrl(serviceName), 'createHistoryEvents', [request], additionalHeaders));
    }
};
